import React, {useState} from 'react';
import './ListaAsistencia.css';
import api from '../../../services/api';
import swal from 'sweetalert';
import Loader from '../../Loader/Loader.js';

const ListaAsistenciaComponent = () => {
    const formato = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'America/Mazatlan',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    });
    const today = formato.format(new Date());
    const [alumnos, setAlumnos] = useState([]);
    const [date, setDate] = useState(today);
    const [turno, setTutno] = useState("MATUTINO");
    const [grado, setGrado] = useState("PRIMERO");
    const [grupo, setGrupo] = useState(null);
    const [showLoader, setShowLoader] = useState(false);

    const buscarAlumnos = async () => {
        try {
            const response = await api.getAsistencias({turno, grado, date, grupo});
            setAlumnos(response.data.data);
        } catch (error) {
            swal("Error", "Intente de nuevo más tarde.", "error");
            return;
        }
    }

    const actualizarListas = async () => {
        try {
            setShowLoader(true);
            const response = await api.postActualizarAsistencia({date});
            if (response.data.success) {
                if (response.data.data.length > 0) {
                    swal("Exito!", "Asistencias actualizadas correctamente", "success");
                } else {
                    swal("Error", "No hay registros de ese dia", "error");
                }
            } else {
                swal("Error", response.data.data, "error");
            }
            setShowLoader(false);
        } catch (error) {
            setShowLoader(false);
            swal("Error", "Intente de nuevo más tarde.", "error");
            return;
        }
    }

    return (
        <>
        <div className= "seccion-materias hover-seccion fade-in">
            <div className= "seccion-centro">
                <div className='container-filtros'>
                    <div className='filtros-input filtros-input-date'>
                        <label>Seleccione el día</label>
                        <input type="date" value={date} onChange={ e => (setDate(e.target.value))}></input>
                    </div>
                    <div className='filtros-input'>
                        <label>Turno</label>
                        <select name="Turno" onChange={e => (setTutno(e.target.value))}>
                            <option value="MATUTINO" defaultChecked>MATUTINO</option>
                            <option value="VESPERTINO">VESPERTINO</option>
                        </select>
                    </div>
                    <div className='filtros-input'>
                        <label>Grado</label>
                        <select name="Grado" onChange={e => (setGrado(e.target.value))}>
                            <option value="PRIMERO" defaultChecked>PRIMERO</option>
                            <option value="SEGUNDO">SEGUNDO</option>
                            <option value="TERCERO">TERCERO</option>
                        </select>
                    </div>
                    <div className='filtros-input'>
                        <label>Grupo</label>
                        <input type="number" onChange={ e => (setGrupo(e.target.value))}></input>
                    </div>
                    <button onClick={buscarAlumnos}>BUSCAR</button>
                    <button onClick={actualizarListas} id='button-actualizar'>ACTUALIZAR</button>
                </div>
                <div className= "seccion-tabla-asistencias">
                    <div className= "hover-elemento">
                        {/* TABLA */}
                        <div className= "contenedor-tabla-asistencias">
                            <table className= "tabla-asistencias">
                                <thead>
                                    <tr>
                                        <th><label>FECHA</label></th>
                                        <th><label>MATRICULA</label></th>
                                        <th><label>ALUMNO</label></th>
                                        <th><label>TURNO</label></th>
                                        <th><label>GRADO</label></th>
                                        <th><label>GRUPO</label></th>
                                        <th><label>ENTRADA</label></th>
                                        <th><label>SALIDA</label></th>
                                        <th><label>MANUAL</label></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    { alumnos && alumnos.map( (alumno, i) => { 
                                        return (
                                        <tr key={ i }>
                                            <td>{ alumno.FECHA.split('T')[0] }</td>
                                            <td>{ alumno.MATRICULA }</td>
                                            <td>{ alumno.ALUMNO }</td>
                                            <td>{ alumno.TURNO }</td>
                                            <td>{ alumno.GRADO }</td>
                                            <td>{ alumno.GRUPO }</td>
                                            <td>{ alumno.ENTRADA }</td>
                                            <td>{ alumno.SALIDA }</td>
                                            <td>{ alumno.MANUAL }</td>
                                        </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Loader visible={showLoader} text={'Actualizando Asistencias'} ></Loader>
        </>
    );
};

export default ListaAsistenciaComponent;